import { isNil } from "lodash";

export function isNilOrNaN(value: any): boolean {
	return isNil(value) || (typeof value === "number" && isNaN(value));
}
